import { render, staticRenderFns } from "./StripeAppleGooglePay.vue?vue&type=template&id=a282df60&scoped=true&"
import script from "./StripeAppleGooglePay.vue?vue&type=script&lang=js&"
export * from "./StripeAppleGooglePay.vue?vue&type=script&lang=js&"
import style0 from "./StripeAppleGooglePay.vue?vue&type=style&index=0&id=a282df60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a282df60",
  null
  
)

export default component.exports